module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Here We Go Again")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("One of the nice things about being a goody two-shoes Buckhead housewife is that nobody would ever guess I’d commit a crime, much less kidnap anybody. I have the ultimate mommy face and “comfy” physique. All four of my best friends and I look like the respectable, middle-class, middle-aged women we are.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Okay, with the exception of SuSu till this year, but even she has gone respectable lately.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I still can scarcely believe we pulled it off—a real Keystone Cops kidnapping, complete with security guards chasing me and a desperate getaway. The law and conscience aside, my mother—a true lady—brought me up better than that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But as SuSu always used to say (before she became a law student last fall), “Rules are made to be broken,” and boy, did we ever break them. We’re talking high crimes and misdemeanors. Not that we were strangers to the occasional well-intentioned misdemeanor, especially when it involved helping out one of our own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But I’m getting ahead of myself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("First, let me put this all in proper context.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If there’s to be any hope for higher civilization, some things in this life have to be held sacred, and for me and my four best friends (Teeny, SuSu, Linda, and Diane) it’s our second-Tuesday, monthly Red Hat luncheons at the Swan Coach House tearoom in Buckhead. The only acceptable excuses for absence are death, incarceration, or nonelective hospitalization.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Through all the triumphs and tragedies of more than three decades—including Junior League, potty training, wayward husbands, wayward children, menopause, aging parents, and the frightful resurrection of seventies clothing—our commitment to meeting monthly, for ourselves and one another, has kept us close. That, and the Twelve Sacred Traditions we’ve evolved since we were fellow Mademoiselle pledges from Northside, Westminster, Lovett, and Dykes high schools back in the sixties.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the most amazing thing about our monthly luncheons is, no matter how well we know one another, there’s no telling what surprises are going to crop up over the Coach House’s white tablecloths and fresh centerpieces.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Take last April….")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Swan Coach House tearoom, Atlanta. April 8, 2003. 10:55 A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("As always, I got to the Swan Coach House Restaurant before the valet parking, so I saved myself a tip and pulled into a slot under a canopy of blooming dogwoods and towering, newly tasseled oaks across from the main entrance. Spring—a precious, unpredictable event in Atlanta—had come early this year, confusing the plants into a glorious, out-of-synch display that sent the pollen count soaring along with the spirits of the populace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As I crossed to enter, I savored the warm air perfumed by narcissus and hyacinths. The clouds of oak and yellow pine pollen would come later, driving everyone inside and providing a bounty for car washes and sellers of antihistamines, but for now, the day was perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once inside the gift shop, I made my usual cursory circuit to see what was new since last month in the tempting array of gorgeous things. Fortunately for my budget, nothing sang to me, so I proceeded down the short flight of stairs to the restaurant foyer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("Funny, how you fall into ruts without ever realizing it till they’re interrupted. I’ve always liked to get to our Red Hat luncheons first, before the tables fill and the floral padded walls rumble with a polite roar of female chatter and chairs scraping on the dark wood floors. Our regular waitress, Maria, always seats me at our usual banquette in the back corner and brings me fresh, no-cal hot lemonade right away, which I load with Sweet’N Low and sip slowly, taking advantage of ")]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("the waiting quiet to shake off the mundane concerns of my life and focus on friendship.")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But that morning when I entered the dining room from the bright yellow foyer, I saw that SuSu had already beaten me there for the third time in as many months—a total turnaround from her pathological lateness of the past two decades. I shook off a tiny stab of disappointment that I wouldn’t have my settling-in time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She waved, looking like a just-ripe Lauren Bacall in a red cashmere beret and bulky black turtleneck sweater over slim black slacks. She’d finally gotten with the program about wearing a red hat a year ago, but the purple clothing thing was still a no-go.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Talk about a makeover. Gone were the brassy red hair and too-young clothes from SuSu’s bitter, wayward years following her divorce. With the help of Teeny’s generosity, she’d aced her LSAT, gotten into Emory Law School, and adopted a whole new, professional look. Classic to the core in her smooth, shining, dark-honey, chin-length hair and elegant wardrobe (most of which came from Teeny’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perfect")]), _vm._v(" line of real-woman clothes) SuSu already looked like the domestic relations lawyer she would be when she graduated in another two years. Every time I saw her this way, it made my heart swell with pride for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As always, an aura of smoke-tainted perfume surrounded her. She’d reformed, but not completely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How’s school?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We’d been busy praying all year for good grades, though SuSu had always been brilliantly book smart. It was just men she didn’t have a lick of sense about.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Brutal,” she grumped. “And, Georgia, you’ll never guess what my study group did to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I knew it was major; she rarely called me by name.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After all our years as friends, I fell instantly into the tried-and-true rhythm of our conversations. “No. What did your study group do to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They invited in a new guy without even asking me, then stuck me with him as a study partner for tort review,” she fumed. “Probably stuck me with him because he’s even older than I am. I guess the legal eaglets think it’s pretty funny, but I sure don’t.”")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The old SuSu would have cussed a blue streak next, but the new SuSu bottled that all up and minced out a tame, “I am "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("so")]), _vm._v(" annoyed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maria arrived with warm mini muffins and took advantage of the break in conversation to ask me, “Excuse me, but would madam like the usual, or perhaps some fresh-brewed coffee this morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mmmmm. Coffee sounded good for a change. Iced tea season was still a few weeks away. “Coffee, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I returned to our conversation, surprised that SuSu would mind studying with a man “full-growed.” Last fall she’d solemnly sworn off stud puppies, a resolution she’d already broken several times, but Tradition Eight (No beating ourselves up—or each other—when we blow it) had kept us from mentioning her “slips.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is he a problem?” I asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll say.” SuSu adjusted her beret with her perfect American manicure. Gone were the red talons of the past. “He’s the stupid, embarrassing Mattress Man!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tucked my chin. “The guy on those cable ads?” The one who stood there dressed in a blue baby bonnet and matching footed pajamas, singing mangled lullabies with his ukulele to promote his chain of mattress stores?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” SuSu bit out. “And he’s as big an idiot as he looks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Having been the gullible brunt of many a prank over the years, I eyed her with suspicion. Last time I looked, they didn’t let idiots into Emory Law School. “You’re kidding. This is some April Fools’ joke, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu glowered. “Do I look like I’m kidding?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mouth pursed, I shook my head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The joke’s on me, kiddo, and the only April Fool is him. The guy’s totally annoying. Always joking around when we should be studying.” Her nostrils flared. “Not everybody has a photographic memory like he does.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I injected logic, futile though it was. “Ah. A photographic memory. Maybe that’s why your study partners thought he could benefit the group.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu would not be appeased. “Maybe so, but they at least should have asked me first.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("I had to bite my lips to keep from laughing at the idea of SuSu, ")]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("trapped, studying with a man who was famous for wearing a blue baby bonnet and footed pajamas on late-night TV ads. “I always thought he was kind of cute, in an older sort of way. Nice dimples.”")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, he’s bald as a mango under that baby bonnet,” she grumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How can he go to law school and run those stores?” I wondered aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He doesn’t. He sold them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But I just saw him on a new ad a few days ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her mouth flattened. “That was part of the deal. They paid him a fortune to keep making the ads. At his age, you’d think he’d be embarrassed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This, from the woman who’d come back from the bathroom at a charity fund-raiser at the Piedmont Driving Club dragging a toilet-paper comet, with her dress caught up in her sheer pantyhose, exposing half her fanny to high society. But SuSu’s memory worked in adverse proportion to her alcohol consumption, so she probably didn’t even remember it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I looked up to see Linda stomping toward us, her usually sunny round face grim as thunder and her broad-brimmed red hat askew on her soft gray curls.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu abandoned the subject of the Mattress Man. “Whoo,” she murmured as Linda approached. “Looks like she’s got a bee up her butt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Very out of character for our level-headed Linda.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda dropped her open-topped Kate Spade bag by her chair as she plunked down into her regular seat beside me, then started fanning herself vigorously with her napkin, her plump neck red and mottled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu and I exchanged knowing looks, recognizing the symptoms immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“At last,” I crowed. “She’s having a hot flash. Coming to join the rest of us on the shady side of the hill.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda glared at me like a bull eyeing a toreador. “It is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" a hot flash,” she snapped out. “And just because y’all have all gone through the change before me doesn’t mean I have to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oooooh,” SuSu gloated. “Moody, moody, moody. Been there, done that. It’s the hormones talking, baby. Estrogen in the major minuses.” She patted Linda’s arm. “Time to crank up the old HRT, and you’ll be right as rain.”")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda recoiled from her touch, irate. “Contrary to your personal experience, SuSu,” she snapped, “some people don’t try to solve everything with a pill. Or a drink.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Whoa! Serious personal foul! We never discussed SuSu’s drinking. Granted, it had grown progressively worse since her second husband had left her in the lurch, but SuSu was still fully functional. We accepted the drinking as her problem, and hers alone, to deal with. “Fixing” each other (unless it was a life-or-death situation) was strictly taboo.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Why Linda had said that was beyond me. I doubted even menopause would have sent her for the jugular that way. There had to be something else.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A look of deep concern overrode whatever offense SuSu might have felt. She leaned closer. “Linda, honey, what’s the matter?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda looked like she was about to burst into tears.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Please God, not Brooks. It couldn’t be. They had the perfect marriage. Linda’s plump little urologist husband adored her. (Maybe because she still got up cheerfully at five every workday of the world to make him a hot breakfast before his hospital rounds.) If he’d gotten tangled up with some chickie-boom, I’d kill him with my bare hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda seemed to be searching for something to say, then blurted out, “It’s Osama Damned Boyfriend,” her nickname for her daughter Abby’s live-in boyfriend of eight years. “Who else?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Abby, six months before graduation at the top of her class at Agnes Scott, had abdicated her role as Jewish princess and dropped out to become a hairdresser, moving to Virginia Highlands with Osama (his real name), a first-generation Iranian-American, Rastafarian tattoo artist ten years her senior. (A very confused, but laid-back young man.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At least he didn’t eat pork or drink. They had that in common.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he was still a Jewish mother’s nightmare. Brooks and Linda had kept open the lines of communication (and, against my advice, their pocketbook). Now, eight years later, the unlikely young couple seemed genuinely happy, in an underachieving, counterculture sort of way. Still, he’d always been Osama Damned Boyfriend to Linda. “Abby is wasting herself on that pot-smoking loafer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu eyed her with lawyerly shrewdness. “I don’t think that’s really it. Abby’s been doing fine. Has something new happened?”")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda scowled and went pale.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I offered her the basket of tiny muffins. “Take one,” I mothered. “You look like your blood sugar just tanked.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She went green around the gills and shook her head. “Back off, Georgia.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Only something really serious could make a polecat out of our placid Linda. Something big was bothering her. My overactive imagination projected the worst. “Ohmygosh. Is Abby pregnant?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda all but took my head off. “No! She is not pregnant! That would be good news. At least I’d have a grandchild.” She fanned herself harder. “Tradition Five, y’all. Leave me alone. Quit ganging up on me when I’m feeling unsteady.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She said the last so loud that several heads turned at nearby tables.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu’s expression clouded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Afraid she’d make things worse by trying to pin Linda down, I called a Do Over. “Tradition One, then.” I motioned for Maria. “Linda, do you think a cup of tea might make you feel better?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The minute I said it, I realized how condescending it sounded, but Linda was through attacking. She just looked miserable and nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The usual,” I told Maria. “And a couple of extra napkins, please.” The way Linda looked, I might have to put a cold compress on the back of her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If this was the start of menopause, she was in for a lulu.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny provided a welcome distraction when she glided in wearing a lightweight, red faux-suede skirt with a matching jacket over a cutwork purple shell (size 3), topped by a gaucho-inspired flat-brimmed red straw hat that made the most of her blond coloring. I recognized the design as one Diane had done for the petite division of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perfect")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When our pal Diane had ended up a displaced housewife, Teeny (the mogul of our group, who had parlayed her nest egg into twenty million during the market’s zenith) had taken advantage of Diane’s bone-deep Southern class and penchant for organization by hiring Diane to supervise and design "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perfect")]), _vm._v(", a line of elegant, comfortable, easy-care clothing for real-women’s bodies. The concept had hit pay dirt with America’s baby boomers who longed for the return of clothes that made you say, “What a gorgeous outfit! It makes you look so "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("slim!")]), _vm._v("” Not that Teeny needed to look any slimmer than she was.")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But watching her approach us, I wasn’t focused on her outfit. I was focused on the uncharacteristic frown that drew her precise blond brows together.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even when she’d been stuck married to philandering Reid, Teeny had presented a genteel mask of pleasantness in public. What was up with her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe the cosmic nasties were just in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All three of us watched her take her place. “I haven’t seen you frown that way since the divorce, Teens,” Linda ventured, her genuine concern tempered, no doubt, by the chance to shift our attention away from herself. “What’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I really couldn’t say,” Teeny murmured, tacitly evoking Tradition Five. (Mind your own business.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I really couldn’t say")]), _vm._v(" had been our socially acceptable alternative to “don’t ask,” since we’d had it drilled into our heads as Mademoiselle pledges back in high school. It warded off unwanted questions and avoided hurting feelings when somebody asked a question best left unanswered, like, “What do you think of my tattoo?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oooooh. My mind took a left back to the previous subject. Maybe Linda was upset because Abby had gotten a tattoo.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nah. Whatever it was, it was something worse than a mere tattoo.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny looked down at the table. “Right now, it’s confidential. But y’all will be the first I call on if anything develops.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Again, I projected the worst. “You haven’t lost all your money, have you?” Could a person lose twenty million all at once? Probably not. Still…“’Cause if you did, you can move in with us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not that she’d want to stay in our humble little Collier Hills ranch after life in her gorgeous double condo on Peachtree, high above Buckhead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Careful not to skew my red fedora with her wide-brimmed gaucho hat, Teeny gave me a sideways hug, her face aglow with affection. “Bless your heart. No, honey. I’m set for life, no matter what happens to the economy.” She drew back. “Someone I care about is in trouble, that’s all. I want to help, but sometimes helping is hurting, if you’re rescuing them from the consequences of their actions.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("I wondered about her two hard-drinking, high-living sons. They ")]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("adored their mama, but were following in their wayward father’s footsteps.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maria emerged through the swinging doors beyond our table, with a tray bearing fresh muffins, Linda’s tea, and Teeny’s orange juice. Maria knew all our individual preferences, as well as the predictable patterns of our luncheons.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As patrons began to filter into the dining room, Teeny and I started chuffing muffins and butter. I’d been on Atkins for six months and dropped twenty pounds, then switched to South Beach, but when the Red Hats got together once a month, I ate whatever the heck I wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda took only tiny sips of her tea.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So,” I said to Teeny from behind my napkin before my mouth was decently empty. “How are those precious grandbabies?” Grandbabies were always a safe topic. Teeny had two granddaughters, honeymoon babies both, born ten and twelve months after her sons married gorgeous, high-powered businesswomen in a double ceremony. “How old are they now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Caroline is three months, Catherine is five. And they’re both adorable. Caroline’s so interested in everything, but she’ll happily entertain herself with a toy. The only time she cries is when she’s wet or hungry. Catherine, though, that’s a different story. She’s a wiggle worm, already reaching for things. Busy, busy, busy. Her mama’s going to need that nanny I gave them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m green with jealousy about those grandbabies,” I confessed. The way my son and daughter were dragging their feet, I’d be on Social Security before I got a grandbaby of my own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At thirty, my son, Jack, showed no signs of settling down now that he’d completed his MBA at State and gone to work for Home Depot Corporate. And at twenty-five, my daughter, Callie, was in the throes of getting her doctorate in English at Georgia, which seemed to leave no time for serious relationships, much less marriage and kids. (Marriage, then kids, was the preferred order in my conservative Christian household, thank you very much.) “Can I borrow yours sometime?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure.” Teeny patted my arm in sympathy. “Want one, or both?” She was serious, even though I really hadn’t been. Her heart was as big as her fortune.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I shifted the topic slightly. “How did your DILs”—daughters-in-law—“react to the nannies you gave them?” I would’ve leapt for joy at such a gift, but the boys’ wives were both real estate attorneys, used to running things themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They were delighted,” Teeny said. “The DILs are real career women. Couldn’t wait to get back to work. And I think it helped that the nannies are both in their fifties and so wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny’s sons had said she was crazy to fork out an annual salary of seventy-five thousand for each of the nannies, but there was method in her madness. No daycare for her precious grandbabies. Teeny’s granddaughters—and their brothers and sisters to come—were going to learn solid values, good manners, and personal responsibility at home, whether their parents were willing to take the time to teach them or not.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I slathered plain butter on a mini muffin and popped it into my mouth, then chased it with a robust slug of coffee. “Mmmmm.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The room was beginning to get crowded, and I looked up to see Diane breeze in past a large group, flushed and smiling in an elegant dark purple, washable mock-linen tunic over matching drawstring pants (another of her designs). Topping it off was her divorce hat, a red-sequined ball cap that declared "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FREE AT LAST")]), _vm._v(" in zircons above an appliqué of a white dove in flight, a sure sign she was full of herself and raring to go.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thank goodness. Somebody in a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("good")]), _vm._v(" mood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, y’all. What’re we talking about here?” Diane asked briskly as she took her seat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The DILs like the nannies,” I informed her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teeny cocked her head at Diane. “You’re awfully sparkly for this time of day, even for you. What’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane blushed to the faint white roots of her brown hair. “I’m happy, that’s all. It’s spring. Everything’s gorgeous. I love my job. Isn’t it okay for a girl to be happy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Girl? We exchanged sidelong glances. “Sure,” I said. “Long as you tell us what’s put that cake-eatin’ grin on your face.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She flushed even deeper. “Not yet. I mean, really, there’s not really anything to tell,” she dithered. “Yet.”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu reared back. “Oh, honey, I know that look. Diane’s got a guy.” Big news, since decent, unattached men—who weren’t looking for twenty-somethings—were scarcer than unbleached teeth in Buckhead. “Tell. Tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clearly busted, Diane invoked, “Tradition Five.” (Mind your own business.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tradition Six,” I countered. (Girls first. No man shall come between us.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tradition Seven,” SuSu couped. (No secret affairs.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, for goodness’ sake,” Diane flustered out. “Who said anything about an affair? It was only a phone call. Not even a date.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the mention of the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("affair")]), _vm._v(", heads turned at nearby tables, and Diane shrank, flaming. “So a guy called me,” she whispered tightly. “Now you’ve probably jinxed the whole thing by making me talk about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda did a dry ceremonial spit to ward off the jinx. “Tui, tui, tui.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brims converging, we closed into a tight huddle over the tiny vase of alstralemeria at the center of the table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Get real,” SuSu said, clearly enjoying the opportunity to put Diane on the hot seat. “Talking about men doesn’t make a bit of difference, and you know it. They do what they want, regardless.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So,” I prodded, “who is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’d you meet him?” Linda asked atop my question.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Good thing Diane had low blood pressure, or I might have been afraid she would stroke out, red as she was. She got all prissy. “On the Internet, if you must know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I straightened, aghast. “Don’t tell me you’ve been going to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chat rooms")]), _vm._v(".” The virtual equivalent of bar-crawling! And it was common knowledge that chat-room people lied their heads off. Heck, you couldn’t even be sure the guy you were talking to was really a guy! Not that I knew from personal experience, mind you. I was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" happily married since recently falling in love with my long-suffering husband. More about that in a minute.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Diane shook her head in vehement denial, but all the subtle signs told me she had, in fact, been chatting. “Nothing like that.” She crossed her legs. “I was just noodling around on the Web and found ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("this site where you could register to contact old classmates, so I registered my class at Westminster. And lo and behold, this guy I knew in grammar school e-mailed me.”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And?” Teeny’s brows rose in anticipation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane’s blush shifted to a glow. “And so, we’ve e-mailed for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s a while?” SuSu cross-examined.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane buttered a roll with inordinate concentration. “A few months.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A few months?” SuSu blustered. “And this is the first we’re hearing about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, back off,” I chided. “Tradition Eight.” (No beating ourselves or each other up over anything.) “Can’t you see, she’s happy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At least she had been, till we’d started grilling her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maria arrived with menus (as if we needed them) and refills. After making sure we all had what we needed, she discreetly vanished.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By now, the level of chatter in the dining room was so high, we no longer had to worry about being overheard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So,” I coaxed Diane with a sly grin, “who is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane went coy as a teenager, quite a contrast to her usual nononsense self. “Clay Williams. My sixth-grade boyfriend. I wore his ID bracelet the whole school year. Then his father got transferred to Cleveland.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ooooo. An old flame.” I lifted my coffee in a toast. “I smell a real love story brewing here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane deflected the embarrassing attention by shifting to me. “Speaking of love stories, how high have you gotten those hearth fires burning lately?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now it was my turn to color up. SuSu wasn’t the only one who’d turned over a new leaf at midlife. Thanks to Teeny’s intervention the year before, I’d fallen head over heels in love with my husband for the first time, after thirty years of taking his quiet devotion for granted. I never told him that I hadn’t loved him as I should have before then; I just did my best to show him how I loved him now, body and soul.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("John had been shocked, but delighted by my newfound ardor, and we’d both been having fun spicing things up. “Well, I’m considering a really sexy little Easter Bunny outfit,” I confessed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That ought to put John in a hoppin’ good mood,” Teeny said.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If that doesn’t, nothing will.” SuSu waggled her eyebrows, her voice low. “I hope it’s a crotchless number with ears and a fluffy tail. The old Easter egg hunt will take on a whole new meaning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“SuSu!” Blood flooded my face in embarrassment. “There is no need to get crass.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She may have adopted a professional persona, but my childhood friend still had a ribald streak. That’s why I’d asked her to come with me to the adult toy store the next time I went to pick out an outfit. But I knew better than to get all huffy. This bunch would never leave you alone if you got all huffy. “I think we can come up with a few exciting rites of spring,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Loosening up at last, Linda rolled her eyes at me. “If I showed up in that sexy little getup, Brooks would laugh his head off. Or have me committed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As well he should,” SuSu said. “You’re Jewish, for cryin’ out loud, even if you do have a nonpracticing Iranian Rastafarian common-law son-in-law. You can’t be the Easter Bunny.” She narrowed her eyes at Linda in appraisal. “But maybe something in a silver lamé menorah…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thought of plump Linda in nothing but a few strips of lamé was daunting enough for Teeny to revert to Diane’s Internet guy. “So, this childhood sweetheart.” Teeny leaned forward, her blue eyes dancing with speculation. “Does he still live in Cleveland?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Actually, no.” Diane finally decided to be forthcoming, in typically brisk, organized form. “Graduated from Yale, then did his doctorate in history at Duke, where he married and had two daughters. Taught there till his wife got cancer six years ago, and he retired to take care of her. Lost her three years ago.” Her eyes went soft with sympathy. “She sounds like a wonderful woman. Poor guy took it really hard.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rest of us exchanged pregnant glances.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oblivious, she went on. “He’s been doing research and spending a lot of time with his two granddaughters, but I think he’s awfully lonely.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bull’s-eye with the boyfriend,” Teeny exhorted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("“Ohmygod.” SuSu spread her demure American manicure for emphasis. “One mouse click, and Shy Di comes up with the Holy Grail of ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("men: a devoted, literate widower at the perfect stage for a fresh start—who had a crush on her once. I hear wedding bells.”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“SuSu.” Diane bristled. “Back off, and I mean it. He called me. One phone call. Granted, it was a nice one.” Her posture mellowed. “A great one, as a matter of fact. But now you have to go all overboard and spoil it.” She opened her menu and scowled at the selections we all knew by heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chastened, Teeny and I followed suit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu at least had the decency to apologize. “Sorry, honey. I didn’t mean to push. Can I call a Do Over?” (Tradition One.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The question was rhetorical. Any of us could call a Do Over at any time and get a fresh start. It was the first and best of our Twelve Sacred Traditions, since forgiveness is the primary requirement for lasting friendship. More about those later.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Diane’s face cleared. “Sure.” Even if she should decide after all these years to hold a grudge, she wouldn’t have a place to put it, bless her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda, pinked up but still a bit pale, smoothed the napkin in her lap. “Who’s got the joke? Let’s hear it. I could use a laugh.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In all the years we’d been lunching together (long before we were Red Hats), we’d taken turns bringing a joke to our monthly get-togethers. Teeny was terrible at it, Diane and I were fair with occasional inspirations, SuSu tended toward the crass, and Linda was hit-or-miss. But it gave us something to laugh at, one way or the other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We all looked around at each other, shrugging. When nobody came forth, we went for our pocket calendars and came up with a universal “You,” pointing at Linda.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Damn,” she grumped. “I completely forgot.” Her neck mottled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay,” I deflected. “Who’s got a pinch-hitter joke?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This had happened before, and we usually got a good laugh out of trying to come up with something. But with Teeny distracted and Linda all grumpy and SuSu ticked off at her study group, the odds weren’t good.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay,” I volunteered. “Here goes: What did the skeleton say to the bartender?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu offered an anemic “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bring me a beer. And a mop.” I grinned, nodding.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Moans all around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay,” I defended. “Joke’s done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu leaned past Linda for an exaggerated “Ha, ha, ha.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda reared away from her with a fresh frown. “Phew. M.O.”—makeover. Tradition Five. “You smell like an ashtray.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Without invitation or warning, SuSu delved into Linda’s open purse. “Got any gum?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Linda responded with a look of panic and a vehement “No!” that clearly had nothing to do with the gum, but she was too late.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SuSu had already come up with an unopened early pregnancy test in her hand. “Ohmygod!” Her gaze snapped to Linda’s. “This is for Abby, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Our precious goddaughter, pregnant out of wedlock! By a Rastafarian Muslim tattoo artist!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Flushed to a shade just shy of her purple jumper, Linda snatched the narrow box and jammed it back into her bag. “No. This is not for Abby.” A dozen emotions warred in her usually placid face. Then two fat tears rolled down her cheeks as she forced out a thick, wavering whisper. “It’s for me.”")])])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page15"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36fdfe89","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312316914_ch01.vue
// module id = 66
// module chunks = 0